import { Component, OnInit } from '@angular/core';
import { NotificationService } from '../../../../../services/notification.service'
import { MessageService } from "primeng/api";
import { ConfirmationService } from "primeng/api";

@Component({
  selector: 'app-push-notification-broadcast',
  templateUrl: './push-notification-broadcast.component.html',
  styleUrls: ['./push-notification-broadcast.component.scss'],
  providers: [MessageService]
})
export class PushNotificationBroadcastComponent implements OnInit {

  public notification : any = {
    title: "",
    message: "",
    preview : true,
    filters:{
      android : true,
      iOS: true,
      lastActivityAge : null,
      usersWithNumberOfOpens : null
    }
  }
  public sending : boolean = false;

  constructor(
    public notificationService : NotificationService,
    private messageService: MessageService,
    public confirmationService: ConfirmationService
  ) { }

  ngOnInit() {
  }

  sendPreview(){
    this.notification.preview = true;
    this.sending = true;
    this.notificationService.sendGlobalPushNotification(this.notification).subscribe(result=>{
      this.messageService.add({life: 10000, detail: "Message has been queued to be sent to "+result.devices+" devices."})
      this.sending = false;
    },error=>{
      this.sending = false;
    });
  }

  sendBroadcast(){
    this.notification.preview = false;
    this.sending = true;
    this.notificationService.sendGlobalPushNotification(this.notification).subscribe(result=>{
      this.sending = false;
      this.messageService.add({life: 10000, detail: "Message has been queued to be sent to "+result.devices+" devices."});
      this.notification = {
        title: "",
        message: "",
        preview : true,
        filters:{
          android : true,
          iOS: true,
          lastActivityAge : null,
          usersWithNumberOfOpens : null
        }
      };
    },error=>{
      this.sending = false;
    });
  }

  valid(){
    return this.notification.title.length > 0 && this.notification.message.length > 0;
  }

}
